<template>
    <div>
        <b-row class="justify-content-center">
            <b-col cols="11 text-left">
                <slot name="logo">
                    <logo />
                </slot>
            </b-col>
            <b-col cols="11">
                <slot name="main"></slot>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import Logo from "@/components/Logo.vue";

export default {
    name: "manager-layout",
    data: function () {
        return {};
    },
    components: { Logo },
};
</script>

<style lang="scss">

</style>
